<template>
    <v-container fluid class="my-0 pa-0">
        <q-content-submenu ref="contentMenu"></q-content-submenu>
        <!-- Charts-->
        <div class="mx-5 q-sticky-buffer">
            <v-progress-linear color="primary" indeterminate v-if="!agent"></v-progress-linear>
            <v-row v-else justify="space-between" align="stretch" class="mx-5">
                <v-col cols="6" id="v-agency-3">
                    <h2>{{ agent.AgentName }} Agency Structure</h2>
                </v-col>
                <v-col cols="6" id="v-agency-3">
                    <q-tenant-select v-model="tenant_id"></q-tenant-select>
                </v-col>
                <v-col cols="12">
                    <q-agency-structure-chart :agent="agent"></q-agency-structure-chart>
                </v-col>
            </v-row>
        </div>
    </v-container>
</template>

<script>
import QContentSubmenu from '@/components/navigation/Submenus/QContentSubmenu.vue';
import QAgencyStructureChart from '@/components/charts/QAgencyStructureChart.vue'
import QAgencyBuildingSubmenu from '@/components/navigation/Submenus/QAgencyBuildingSubmenu.vue';
import QuilityAPI from '@/store/API/QuilityAPI.js'
import QTenantSelect from '@/components/utils/QTenantSelect.vue'
import Tenant from '@/store/Models/Tenant'
import { EventBus } from '@/event-bus'

export default {
    name: "AgencyDetail",
    data() {
        return {
            agent: null,
            tenant_id: null,
        }
    },
    activated () {
        EventBus.$on('changeTenant', this.setPath)
    },
    deactivated () {
        EventBus.$off('changeTenant', this.setPath)
    },
    methods: {
        processRoute (agentCode) {
            if (agentCode) {
                this.getTenant(agentCode)
            } else {
                this.setDefaultRouteParams()
            }
        },
        async getTenant (agentCode) {
            const agent = await QuilityAPI.getAgentStateless(agentCode)
            this.tenant_id = this.tenant_id || agent.TenantID
            if (this.tenant_id !== this.agent?.TenantID) {
                this.agent = agent
            }
        },
        setDefaultRouteParams () {
            if (this.tenant_id) {
                this.setRouteParams()
            } else if (this.current_tenant?.ID) {
                this.tenant_id = this.current_tenant.ID
            } else {
                this.$router.push('/agency-building/structure/' + this.user.Agent.AgentCode)
            }
        },
        setRouteParams () {
            const tenant = Tenant.find(this.tenant_id)
            this.setPath(tenant)
        },
        setPath (tenant) {
            let path = `/agency-building/structure/${this.user.Agent.AgentCode}`
            if(this.hasRole(['SuperAdmin','Exec','Staff']))
                path = `/agency-building/structure/${tenant.TopLevelAgentCode}`
            
                if (this.$route.path !== path) {
                this.$router.push(path)
            }
        },
    },
    watch: {
        tenant_id () {
            if (!this.tenant_id) { return }
            this.setRouteParams()
        },
        '$route.path': {
            handler () {
                if (this.$route.name !== 'AgencyStructure') { return }
                this.processRoute(this.$route.params.agent_code)
            },
            immediate: true,
        },
    },
    components: {
        QAgencyBuildingSubmenu,
        QAgencyStructureChart,
        QTenantSelect,
        QContentSubmenu
    }
}
</script>
